import {useState} from "react";

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Avatar from "@mui/material/Avatar";
import Typography from '@mui/material/Typography';
import Grid from "@mui/material/Grid";

import "./CustomAccordionStatusFilter.scss";
import {ChevronDownIcon} from "../../styles/icons";
import './CustomAccordian.css';

const CustomAccordionStatusFilter = props => {
  const [expanded, setExpanded] = useState(false);
  const {DetailComponent, SummaryIcon} = props;
  return (
    <Accordion
      expanded={expanded}
      onClick={() => setExpanded(!expanded)}
      sx={{display: props.onlyMobile ? {'xs': 'block', 'sm': 'none'} : 'block'}}
      className="CustomAccordionStatusFilter"
    >
      <AccordionSummary expandIcon={<ChevronDownIcon fill='var(--primary)'/>} className="summary-container">
        <Grid container columnSpacing={{xs: 2}} sx={{alignItems: "center", width: "100%"}}>
          <Grid item sx={{display: 'flex'}}>
            {
              SummaryIcon
                ? <SummaryIcon style={{fill: props.summaryColor, color: props.summaryColor, ...styles.iconDefault}}/>
                : <Avatar src={props.iconUrl} style={styles.iconDefault}/>
            }
          </Grid>
          <Grid item xs>
            <Typography>{props.summaryName}</Typography>
          </Grid>
          <Grid item xs="auto">
            <Typography color={'var(--text)'}>{props.count}</Typography>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails sx={{padding: "0 16px"}}>
        <DetailComponent/>
      </AccordionDetails>
    </Accordion>
  );
};

const styles = {
  iconDefault: {
    width: '42px',
    height:  '42px'
  }
}

export default CustomAccordionStatusFilter;
